import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ResponsiveImage } from '../../components/ResponsiveImage';

import { media } from '../../services/media';

/**
 * Currently not used in IntroWrapper
 */
const IntroWrapperOverlay = css`
    &:before {
        content: '';
        position: absolute;
        background-color: #000000;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0.55;
    }
`;

export const IntroImage = styled.img`
    display: block;
    width: 100%;
    height: auto;
`;

export const IntroWrapper = styled.div`
    background-color: #e0e0da;
    position: relative;
    width: 100%;
    display: flex;

    background-size: cover;
    background-position: center center;
    overflow: hidden;

    ${media.max('lg')} {
        justify-content: flex-end;
        flex-direction: column-reverse;
    }

    ${media.min('lg')} {
        padding: 40px 100px 200px;
        align-items: center;
        justify-content: center;
        min-height: calc(100vh - 80px);
    }
`;

export const IntroBackgroundImage = styled(ResponsiveImage)`
    ${media.min('lg')} {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;

export const IntroText = styled.div`
    position: relative;
    max-width: 100%;

    padding: 60px 0;

    display: flex;

    align-items: flex-end;
    text-align: right;

    width: 100%;
    height: 100%;

    ${media.max('lg')} {
        width: 100%;
        color: #c0c0c0;
        background-color: #005e9c;
        padding: 20px 15px;
        width: 100%;
        justify-content: center;
        text-align: center;
    }

    ${media.min('lg')} {
        color: #c0c0c0;
        position: absolute;
        right: 0;
        bottom: 0;
        justify-content: flex-end;
        background: linear-gradient(
            to bottom right,
            rgb(255 255 255 / 0%) 0%,
            rgb(255 255 255 / 0%) 50%,
            #005e9c 50%,
            #005e9c 100%
        );

        padding: 0px 20px 20px 190px;

        font-size: 3vh;
    }

    ${media.between('lg', 'xxl')} {
        max-width: calc(100vh / 2.71);
        max-height: calc(100vh / 2.71);
    }

    ${media.min('xxl')} {
        max-width: calc(100vh / 2.88);
        max-height: calc(100vh / 2.88);
    }

    > * {
        position: relative;
    }

    h1 {
        font-weight: 300;

        ${media.max('xl')} {
            font-size: 26px;
        }

        ${media.min('xl')} {
            font-size: 68px;
        }
    }

    h3 {
        font-weight: 300;

        ${media.max('xl')} {
            font-size: 18px;
            letter-spacing: 2px;
            word-spacing: 4px;
        }

        ${media.min('xl')} {
            letter-spacing: 5px;
            word-spacing: 8px;
            font-size: 28px;
        }
    }
`;

export const IntroContent = styled.div`
    display: grid;
    align-items: center;
    text-align: center;
    padding: 0 15px;

    ${media.min('md')} {
        grid-template-columns: 1fr 1fr;
        gap: 30px;
        max-height: 50%;
        max-width: 1200px;
    }

    ${media.max('xl')} {
        padding: 40px 15px;
    }

    ${media.min('xl')} {
        /* padding: 0 100px; */
    }

    img {
        max-width: 100%;
    }

    h3 {
        text-align: left;
    }
`;
